import { defineStore, acceptHMRUpdate } from 'pinia'

interface BusinessServiceNameCardState {
  // Pinia state for the service category card selection panel.

  selectedBusinessServiceNameId: string | null
  // Id of the currently selected service category; null when none is selected.
}

export const useBusinessServiceNameCardStore = defineStore('businessServiceNameCard', {
  state: (): BusinessServiceNameCardState => ({
    selectedBusinessServiceNameId: null,
  }),
  getters: {
    hasSelection: (state): boolean => state.selectedBusinessServiceNameId !== null,
  },
  actions: {
    selectServiceCategory(id: string): void {
      if (this.selectedBusinessServiceNameId === id) return
      this.selectedBusinessServiceNameId = id
    },
    clearSelection(): void {
      this.selectedBusinessServiceNameId = null
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBusinessServiceNameCardStore, import.meta.hot))
}
